import SecondServer from '../database/SecondServer'
import {noauthPost} from "../database/apiMethods"
import {urlSiteListUser} from '../database/apiUrls'

export async function ResetCode (props, resetId) {
  const param = encodeURI(resetId)
  const checkUrl = urlSiteListUser(param)
  const ss = new SecondServer(props);
  const resp = await ss.apiData(checkUrl)
  const disp = mapRespToMsg(resp)
  if (disp)
    return {bannerMsg: disp, bannerStyle: "alert-danger reset-fail", bannerShown: true}
  const url = '/tehama/site-list-server/user/support/send-pw-code?username='
  await ss.apiInsertData(url+param, null);
  if (ss.apiSuccess()) 
    return ({bannerMsg: "Please check your email for a reset code", bannerStyle: "alert-success reset-success", bannerShown: true})
  else 
    return ({bannerMsg: ss.getErrorMsg(), bannerStyle: "alert-danger reset-fail", bannerShown: true})
}
function mapRespToMsg (resp) {
  if ((!resp?.data?.data?.users) || resp.data.data.users.length < 1 )
    return "Sorry, that's not user id we know"
  if (resp.data.data.users[0].user_status === 'UNCONFIRMED')
    return 'Sorry, We cannot send email to your unconfirmed address'
  return undefined
}
export async function apiUpdatePwd (email, pwd, resetcode) {
  const body = {'username': email,
                'password': pwd
  }
  const uri = '&code='+encodeURIComponent(resetcode);

  const url = "/tehama/site-list-server/user/support/update-pw?"+uri;
  const resp = await noauthPost (url, body, true);
  return resp
}

